import * as React from 'react'
import { useCallback, useEffect, useRef, useState } from 'react'
import { XMarkIcon } from '@paytrace/pt-skel/Component/Icon'
import { Button } from '@paytrace/pt-skel/Component'

export interface ConfirmationOptions{
  title?: string
  color?: string
  cancelButtonLabel?: string
  confirmButtonLabel?: string
}

interface ConfirmationDialogProps extends ConfirmationOptions{
  isVisible: boolean
  text: string
  className?: string
  onConfirm: () => void
  onCancel: () => void
  onDoNotShowAgainChange: (isChecked: boolean) => void
}

export function EDConfirmationDialog ({ isVisible, text, onConfirm, onCancel, className, ...props }: ConfirmationDialogProps) {
  const { onDoNotShowAgainChange } = props
  const title = props.title || 'Please Confirm'
  const color = props.color || '#3399cc'
  const cancelButtonLabel = props.cancelButtonLabel || 'Cancel'
  const confirmButtonLabel = props.confirmButtonLabel || 'Confirm'

  const dialogRef = useRef<HTMLDialogElement>(null)
  const [dontShowAgain, setDontShowAgain] = useState(false)

  useEffect(() => {
    isVisible ? dialogRef.current?.showModal() : dialogRef.current?.close()
  }, [isVisible, dontShowAgain]
  )
  const handleDoNotShowAgainClick = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setDontShowAgain(event.target.checked)
    if (onDoNotShowAgainChange) {
      onDoNotShowAgainChange(event.target.checked)
    }
  }, [onDoNotShowAgainChange])

  return (
    <dialog ref={dialogRef} className={`confirmation-dialog ${className || ''}`} onClose={onCancel}>
      <div className={'content'}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h2 style={{ color }}>{title}</h2>
          <span onClick={onCancel} className='clickable click-close'>
          <XMarkIcon/>
        </span>
        </div>

        <p>{text}</p>

        <label className='checkbox-container'>
          <input
            type='checkbox'
            checked={dontShowAgain}
            onChange={handleDoNotShowAgainClick}
          />
          <span style={{ paddingLeft: '10px' }}>Don&apos;t show this again</span>
        </label>

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button type='button' className='cancel-button' style={{ color, borderColor: color }}
                  onClick={onCancel}>{cancelButtonLabel}</Button>
          <Button type='button' className='confirm-button' style={{ backgroundColor: color, borderColor: color }}
                  onClick={onConfirm}>{confirmButtonLabel}</Button>
        </div>
      </div>
    </dialog>
  )
}
